import React, { Component } from 'react'
import axios from 'axios'
import RaisedButton from 'material-ui/RaisedButton'
import AppBar from 'material-ui/AppBar'
import Snackbar from 'material-ui/Snackbar'
import Play from './components/Play'
import LeftDrawer from './components/LeftDrawer'
import SerialField from './components/SerialField'
import CodeField from './components/CodeField'
import LinField from './components/LinField'
import { TOKEN_AUTH_FAILED } from './const'
import Progress from './components/Progress'
import CameraIco from 'material-ui/svg-icons/image/camera-alt'
import IconButton from 'material-ui/IconButton'

class Body extends Component {
  constructor(props) {
    super(props)
    // Get params.
    let params = window.location.pathname.split('/')
    params = params.filter(item => item !== '')
    const [code = '', serial = ''] = params

    // Get mode.
    let mode
    const [q, service] = window.location.search
      .substring(1)
      .split('=')
    if (q === 'service' && service === 'qr') {
      mode = 'Normal'
    } else {
      mode = 'Legacy'
    }

    let savedData = localStorage.getItem('sws')
    savedData = savedData ? JSON.parse(savedData) : false

    const defaultData = {
      serials: [],
      token: '',
      user: false
    }
    const { serials, token, user } = savedData
      ? savedData
      : defaultData

    this.state = {
      user,
      mode,
      serials,
      iconMenuOpen: null,
      scannedText: [],
      error: null,
      value: '',
      open: false,
      serial,
      code,
      linEmpty: false,
      lin: '',
      loading: false,
      candelaOptimize: false,
      errorText: '',
      token: token || '',
      generated: null
    }
  }

  addItemEvery = (str, item, every) => {
    for (let i = 0; i < str.length; i++) {
      if (!(i % (every + 1))) {
        str = str.substring(0, i) + item + str.substring(i)
      }
    }
    return str.substring(1)
  }

  handleSnackbar = () => {
    this.setState({
      error: false
    })
  }

  handleToggle = () =>
    this.setState({ open: !this.state.open })

  setToken = newState => {
    this.setState(newState)
  }

  handleGetCode = async () => {
    let { mode, code, lin, serial, token } = this.state
    if (code.length <= 0 || serial.length <= 0) {
      this.setState({
        errorText: 'Please enter Serial or Code.'
      })
    } else if (
      mode === 'Legacy' &&
      serial.replace(/-/g, '').length < 12 &&
      serial.length > 0
    ) {
      this.setState({
        errorText: 'Serial is too short.'
      })
    } else if (
      mode === 'Legacy' &&
      code.replace(/-/g, '').length < 30 &&
      code.length > 0
    ) {
      this.setState({
        errorText: 'Code is too short.'
      })
    } else if (
      mode === 'Normal' &&
      code.replace(/-/g, '').length < 6 &&
      code.length > 0
    ) {
      this.setState({
        errorText: 'Code is too short.'
      })
    } else {
      this.setState({
        loading: true,
	errorText: ''      
      })
      try {
        lin = `/${lin}` || ''

        const service =
          mode === 'Normal' ? '?service=qr' : ''
        let response = await axios.get(
          `/api/get/${serial}/${code}${lin}${service}`,
          {
            headers: { 'x-access-token': token }
          }
        )
        const { generated, error } = response.data
        const newState = {
          loading: false,
          generated,
          error
        }
        if (error === 'Lin is Empty.') {
          newState.linEmpty = true
        }
        if (error === TOKEN_AUTH_FAILED) {
          newState.user = false
        }
        this.setState(newState)
      } catch (e) {
        console.log(e)
      }
    }
  }
  resizeImage = event => {
    var file = event.target.files[0]
    var maxSize = 3000
    var reader = new FileReader()
    var image = new Image()
    var canvas = document.createElement('canvas')
    var dataURItoBlob = function(dataURI) {
      var bytes =
        dataURI.split(',')[0].indexOf('base64') >= 0
          ? atob(dataURI.split(',')[1])
          : unescape(dataURI.split(',')[1])
      var mime = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      var max = bytes.length
      var ia = new Uint8Array(max)
      for (var i = 0; i < max; i++)
        ia[i] = bytes.charCodeAt(i)
      return new Blob([ia], { type: mime })
    }
    var resize = function() {
      var width = image.width
      var height = image.height
      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width
          width = maxSize
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height
          height = maxSize
        }
      }
      canvas.width = width
      canvas.height = height
      canvas
        .getContext('2d')
        .drawImage(image, 0, 0, width, height)
      var dataUrl = canvas.toDataURL('image/jpeg')
      return dataURItoBlob(dataUrl)
    }
    return new Promise(function(ok, no) {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'))
        return
      }
      reader.onload = function(readerEvent) {
        image.onload = function() {
          return ok(resize())
        }
        image.src = readerEvent.target.result
      }
      reader.readAsDataURL(file)
    })
  }

  handleFileUpload = event => {
    this.setState({
      loading: true
    })
    /* var file = event.target.files[0]*/
    this.resizeImage(event).then(file => {
      const data = new FormData()
      data.append('file', file)
      axios.post('/files', data).then(response => {
        if (response.data.text.length > 0) {
          if (this.state.mode === 'Normal') {
            const shtrudelString = response.data.text.find(
              resText => resText.includes('@')
            )
            if (shtrudelString) {
              const [split1, split2] = shtrudelString.split(
                '@'
              )
              /*const featureCode = split1.slice(-2)

               const ultracodes = ['10', '11', '12']
              const [serial, code] = ultracodes.includes(
                featureCode
              )
                ? [split2, split1]
                : [split1, split2]*/
              const [serial, code] = [split1, split2]
              this.setState({
                serial,
                code,
                loading: false
              })
            } else {
              this.setState({
                scannedText: response.data.text,
                loading: false
              })
            }
          } else {
            let errorText
            const newStrings = response.data.text.map(
              item =>
                item
                  .toUpperCase()
                  .replace(/\./g, '-')
                  .replace(/I/g, '1')
                  .replace(/O/g, '0')
            )
            const candelaSerial = newStrings.find(resText =>
              resText.match(/(\d{4})(-\d{4}){2}/)
            )

            let candelaCode = newStrings.find(resText =>
              resText.match(
                /((\d|[A-Z]){6})(-(\d|[A-Z]){6}){4}/
              )
            )
            if (!candelaSerial && !candelaCode) {
              candelaCode = newStrings.find(resText =>
                resText.match(/(-(\d|[A-Z]){6})+/)
              )
              if (candelaCode) {
                errorText =
                  'Code is not complete, please fix it before submiting'
              } else {
                errorText =
                  'Could not find any Serial Number or Code in the image. Please try again.'
              }
            }

            this.setState({
              serial: candelaSerial
                ? candelaSerial
                : this.state.serial,
              code: candelaCode
                ? candelaCode
                : this.state.code,
              loading: false,
              errorText
            })
          }
        }
      })
    })
  }

  handleScanned = key => (event, value) => {
    this.setState({
      iconMenuOpen: null,
      [key]: value
    })
  }

  handleAutoComplete = key => value => {
    this.setState({
      [key]: value
    })
  }

  handleLogout = () => {
    this.setState(
      {
        user: false,
        serials: []
      },
      localStorage.removeItem('sws')
    )
  }

  handleFieldChange = key => {
    return event => {
      this.setState({
        [key]: event.target.value
      })
    }
  }

  gotScannedText = () => {
    return this.state.scannedText.length > 0
  }

  componentDidMount() {
    const { user, code, serial } = this.state
    if (code && serial && user) {
      this.handleGetCode()
    }
  }

  setBodyState = newState => {
    this.setState(newState, () => {
      if (this.state.serial && this.state.code) {
        this.handleGetCode()
      }
    })
  }
  handleRefresh = () => {
    console.log('refresh')
  }

  render() {
    const {
      serials,
      errorText,
      code,
      user,
      generated,
      loading,
      open,
      error,
      lin,
      linEmpty,
      serial,
      scannedText,
      mode
    } = this.state
    return (
      <div>
        <AppBar
          title={`${mode} Mode`}
          onLeftIconButtonTouchTap={this.handleToggle}
          iconElementRight={
            <IconButton>
              <CameraIco />
            </IconButton>
          }
          onRightIconButtonTouchTap={e =>
            this.inputElement.click()
          }
        />
        <Progress loading={loading} />
        <LeftDrawer
          mode={mode}
          user={user}
          setBodyState={this.setBodyState}
          handleLogout={this.handleLogout}
          onTokenChange={this.setToken}
          open={open}
          handleToggle={this.handleToggle}
          handleOnRequestChange={open =>
            this.setState({ open })
          }
        />
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <Snackbar
            open={!!error || false}
            message={error || 'message'}
            autoHideDuration={4500}
            onRequestClose={this.handleSnackbar}
          />

          <SerialField
            serials={serials}
            serial={serial}
            handleFieldChange={this.handleFieldChange(
              'serial'
            )}
            handleUpdateInput={this.handleAutoComplete(
              'serial'
            )}
            gotScannedText={this.gotScannedText()}
            scannedText={scannedText}
            handleScanned={this.handleScanned('serial')}
            mode={mode}
          />
          <CodeField
            code={code}
            handleFieldChange={this.handleFieldChange(
              'code'
            )}
            errorText={errorText}
            gotScannedText={this.gotScannedText()}
            handleScanned={this.handleScanned('code')}
            scannedText={scannedText}
          />
          <LinField
            linEmpty={linEmpty}
            lin={lin}
            handleFieldChange={this.handleFieldChange(
              'lin'
            )}
            gotScannedText={this.gotScannedText()}
            handleScanned={this.handleScanned('lin')}
            scannedText={scannedText}
          />
          <br />
          <RaisedButton
            label="Get Code"
            primary={true}
            disabled={loading}
            onClick={this.handleGetCode}
          />
          {generated && (
            <div
              style={{
                wordBreak: 'break-all',
                width: '223px',
                margin: 'auto',
                textAlign: 'left'
              }}
            >
              {generated.length < 10 ? (
                <h1 style={{ display: 'inline-block' }}>
                  {generated}
                </h1>
              ) : (
                <h2>
                  {this.addItemEvery(generated, '-', 6)}
                </h2>
              )}
              <Play text={generated} />
            </div>
          )}
        </div>
        <input
          ref={input => (this.inputElement = input)}
          type="file"
          style={{ display: 'none' }}
          accept="image/*"
          capture="camera"
          onChange={this.handleFileUpload}
        />
      </div>
    )
  }
}

export default Body



// WEBPACK FOOTER //
// ./src/Body.js